// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  margin-block: 0;
  margin-inline: 0;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

button {
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background-color: initial;
}

li {
  list-style: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/styles/reset.css"],"names":[],"mappings":"AAAA;;;;;;EAME,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  margin-block: 0;\n  margin-inline: 0;\n  padding: 0;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\nbutton {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: none;\n  background-color: initial;\n}\n\nli {\n  list-style: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
